export const site = {
  name: "火影同人漫画",
  slogan: "忍者世界的无限同人宇宙",
  desc: "专注火影忍者同人漫画的在线阅读门户，热门榜单、题材分类、最新更新与必读推荐一站看完。",
};

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热门榜单", href: "#rank" },
  { label: "题材分类", href: "#category" },
  { label: "最新更新", href: "#update" },
  { label: "必读推荐", href: "#featured" },
  { label: "读者口碑", href: "#review" },
  { label: "常见问题", href: "#faq" },
];

export const heroTags = ["第七班日常", "晓之宿命", "木叶群像", "尾兽契约", "忍者学院", "架空番外"];

export interface RankItem {
  id: number;
  title: string;
  category: string;
  views: string;
  score: number;
  desc: string;
  cover: string;
}

export const topList: RankItem[] = [
  {
    id: 1,
    title: "木叶的第七班日常",
    category: "日常治愈",
    views: "428.6万",
    score: 9.7,
    desc: "鸣人、佐助与小樱的烟火气日常，在任务与修行之外，藏着最温柔的羁绊。",
    cover: "https://readdy.ai/api/search-image?query=warm%20anime%20manga%20cover%20illustration%20of%20three%20young%20ninja%20team%20standing%20together%20under%20orange%20sunset%20sky%2C%20stylized%20hand-drawn%20art%2C%20simple%20cream%20background%2C%20soft%20lighting%2C%20no%20text&width=400&height=560&seq=cover-seventh-class&orientation=portrait",
  },
  {
    id: 2,
    title: "晓之宿命",
    category: "热血战斗",
    views: "391.2万",
    score: 9.5,
    desc: "以晓组织视角展开的同人长卷，每个成员的过去与未来都藏在血色月光之下。",
    cover: "https://readdy.ai/api/search-image?query=dark%20moody%20anime%20manga%20cover%20of%20mysterious%20ninja%20figure%20in%20black%20robe%20with%20red%20clouds%20pattern%2C%20crimson%20moon%20background%2C%20stylized%20ink%20illustration%2C%20dramatic%20shadow%2C%20no%20text&width=400&height=560&seq=cover-akatsuki&orientation=portrait",
  },
  {
    id: 3,
    title: "宇智波一族的幻梦",
    category: "悬疑解谜",
    views: "356.8万",
    score: 9.4,
    desc: "写轮眼之下，是幻术编织的梦境，也是宇智波一族不为人知的真实。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20cover%20of%20boy%20with%20sharingan%20red%20eyes%20in%20moonlight%2C%20deep%20indigo%20and%20warm%20amber%20tone%2C%20hand-drawn%20ink%20art%2C%20mysterious%20atmosphere%2C%20no%20text&width=400&height=560&seq=cover-uchiha&orientation=portrait",
  },
  {
    id: 4,
    title: "自来也的弟子日记",
    category: "群像成长",
    views: "302.5万",
    score: 9.2,
    desc: "从妙木山到木叶村，一位传奇忍者与他弟子们的修行与传承之路。",
    cover: "https://readdy.ai/api/search-image?query=warm%20anime%20manga%20cover%20of%20older%20ninja%20sensei%20with%20long%20white%20hair%20mentoring%20young%20apprentice%20in%20forest%2C%20golden%20light%2C%20hand-drawn%20stylized%20illustration%2C%20no%20text&width=400&height=560&seq=cover-jiraiya&orientation=portrait",
  },
  {
    id: 5,
    title: "我爱罗的守护",
    category: "热血战斗",
    views: "287.9万",
    score: 9.1,
    desc: "从孤独的沙之守鹤，到守护村子的风影，一段关于信任与救赎的故事。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20cover%20of%20young%20red-haired%20ninja%20with%20sand%20power%20in%20desert%20under%20warm%20sunlight%2C%20hand-drawn%20ink%20art%2C%20warm%20orange%20tone%2C%20no%20text&width=400&height=560&seq=cover-gaara&orientation=portrait",
  },
];

export interface Manga {
  id: number;
  title: string;
  category: string;
  status: "连载中" | "已完结";
  latest: string;
  views: string;
  score: number;
  tags: string[];
  intro: string;
  cover: string;
}

export const categories = [
  { name: "热血战斗", icon: "ri-sword-line", desc: "忍术对决与巅峰之战", count: 128, color: "bg-accent-500" },
  { name: "日常治愈", icon: "ri-heart-line", desc: "木叶村的温暖时光", count: 96, color: "bg-primary-500" },
  { name: "群像成长", icon: "ri-team-line", desc: "忍者们的修行之路", count: 74, color: "bg-secondary-500" },
  { name: "架空番外", icon: "ri-sparkling-line", desc: "平行世界的奇想", count: 61, color: "bg-primary-500" },
  { name: "悬疑解谜", icon: "ri-question-line", desc: "写轮眼下的真相", count: 43, color: "bg-accent-500" },
  { name: "恋爱番外", icon: "ri-heart-3-line", desc: "隐藏的情愫与约定", count: 38, color: "bg-secondary-500" },
];

export const updateList: Manga[] = [
  {
    id: 1,
    title: "木叶的第七班日常",
    category: "日常治愈",
    status: "连载中",
    latest: "第 48 话",
    views: "428.6万",
    score: 9.7,
    tags: ["第七班", "日常", "羁绊"],
    intro: "任务之外，木叶村每天都上演着烟火气的小故事。",
    cover: "https://readdy.ai/api/search-image?query=warm%20anime%20manga%20cover%20of%20three%20young%20ninja%20team%20sharing%20ramen%20together%2C%20cozy%20hand-drawn%20illustration%2C%20soft%20warm%20light%2C%20cream%20background%2C%20no%20text&width=400&height=560&seq=update-seventh-class&orientation=portrait",
  },
  {
    id: 2,
    title: "晓之宿命",
    category: "热血战斗",
    status: "连载中",
    latest: "第 62 话",
    views: "391.2万",
    score: 9.5,
    tags: ["晓组织", "热血", "宿命"],
    intro: "每个晓成员的选择，都在改变忍界的未来。",
    cover: "https://readdy.ai/api/search-image?query=dark%20dramatic%20anime%20manga%20cover%20of%20two%20ninja%20facing%20each%20other%20in%20storm%2C%20crimson%20and%20black%20palette%2C%20hand-drawn%20ink%20art%2C%20intense%20energy%2C%20no%20text&width=400&height=560&seq=update-akatsuki&orientation=portrait",
  },
  {
    id: 3,
    title: "尾兽契约",
    category: "热血战斗",
    status: "连载中",
    latest: "第 35 话",
    views: "265.4万",
    score: 9.3,
    tags: ["尾兽", "契约", "力量"],
    intro: "人柱力与尾兽之间，从未如此贴近彼此的心。",
    cover: "https://readdy.ai/api/search-image?query=epic%20anime%20manga%20cover%20of%20giant%20orange%20fox%20beast%20and%20young%20ninja%20silhouette%2C%20fiery%20warm%20colors%2C%20hand-drawn%20illustration%2C%20powerful%20energy%2C%20no%20text&width=400&height=560&seq=update-tailed-beast&orientation=portrait",
  },
  {
    id: 4,
    title: "日向雏田的恋爱修行",
    category: "恋爱番外",
    status: "已完结",
    latest: "全 24 话",
    views: "243.1万",
    score: 9.1,
    tags: ["雏田", "恋爱", "成长"],
    intro: "内向的日向少女，鼓起勇气走向喜欢的人。",
    cover: "https://readdy.ai/api/search-image?query=soft%20romantic%20anime%20manga%20cover%20of%20shy%20girl%20with%20dark%20hair%20holding%20flowers%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20hand-drawn%20cute%20illustration%2C%20no%20text&width=400&height=560&seq=update-hinata&orientation=portrait",
  },
  {
    id: 5,
    title: "卡卡西老师的秘密任务",
    category: "悬疑解谜",
    status: "连载中",
    latest: "第 29 话",
    views: "218.7万",
    score: 9.0,
    tags: ["卡卡西", "任务", "悬疑"],
    intro: "面罩之下，藏着一个必须独自完成的秘密任务。",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20anime%20manga%20cover%20of%20silver-haired%20ninja%20in%20rain%20holding%20scroll%2C%20cool%20moody%20hand-drawn%20ink%20art%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=560&seq=update-kakashi&orientation=portrait",
  },
  {
    id: 6,
    title: "疾风传外传·晓月",
    category: "架空番外",
    status: "连载中",
    latest: "第 40 话",
    views: "196.3万",
    score: 8.9,
    tags: ["架空", "晓月", "番外"],
    intro: "另一个世界线里，忍者们的命运走向了全新分支。",
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20cover%20of%20ninja%20standing%20under%20huge%20full%20moon%2C%20dark%20sky%20with%20warm%20orange%20glow%2C%20hand-drawn%20illustration%2C%20dreamy%20atmosphere%2C%20no%20text&width=400&height=560&seq=update-gekko&orientation=portrait",
  },
  {
    id: 7,
    title: "忍者学校的那些事",
    category: "日常治愈",
    status: "已完结",
    latest: "全 36 话",
    views: "172.9万",
    score: 8.8,
    tags: ["学院", "日常", "搞笑"],
    intro: "从入学第一天起，木叶的未来之星们笑料百出。",
    cover: "https://readdy.ai/api/search-image?query=fun%20bright%20anime%20manga%20cover%20of%20happy%20kids%20in%20ninja%20academy%20classroom%2C%20cheerful%20hand-drawn%20illustration%2C%20warm%20pastel%20colors%2C%20no%20text&width=400&height=560&seq=update-academy&orientation=portrait",
  },
  {
    id: 8,
    title: "波之国的桥",
    category: "群像成长",
    status: "连载中",
    latest: "第 18 话",
    views: "148.2万",
    score: 8.7,
    tags: ["波之国", "守护", "成长"],
    intro: "一座桥的建造，串起村民与忍者共同的心愿。",
    cover: "https://readdy.ai/api/search-image?query=serene%20anime%20manga%20cover%20of%20wooden%20bridge%20over%20river%20with%20small%20ninja%20village%20in%20distance%2C%20warm%20sunset%20hand-drawn%20art%2C%20peaceful%2C%20no%20text&width=400&height=560&seq=update-wave&orientation=portrait",
  },
  {
    id: 9,
    title: "风影的假日",
    category: "架空番外",
    status: "已完结",
    latest: "全 20 话",
    views: "135.6万",
    score: 8.6,
    tags: ["我爱罗", "假日", "番外"],
    intro: "卸下风影的重担，我爱罗难得地放了个假。",
    cover: "https://readdy.ai/api/search-image?query=relaxing%20anime%20manga%20cover%20of%20young%20red-haired%20ninja%20enjoying%20day%20at%20oasis%20with%20watermelon%2C%20warm%20sunny%20hand-drawn%20art%2C%20playful%2C%20no%20text&width=400&height=560&seq=update-holiday&orientation=portrait",
  },
];

export const featuredBanners = [
  {
    title: "编辑精选 · 本周必读",
    desc: "「木叶的第七班日常」全网连载，同名高赞同人，追更人数突破 400 万。",
    cover: "https://readdy.ai/api/search-image?query=wide%20banner%20illustration%20of%20anime%20ninja%20village%20at%20warm%20sunset%20with%20three%20heroes%20running%20across%20rooftops%2C%20stylized%20hand-drawn%20art%2C%20fiery%20orange%20sky%2C%20no%20text&width=1200&height=600&seq=banner-featured&orientation=landscape",
  },
  {
    title: "年度长篇 · 口碑之作",
    desc: "「晓之宿命」完结倒计时，晓组织群像篇口碑封神，值得一口气读完。",
    cover: "https://readdy.ai/api/search-image?query=wide%20banner%20illustration%20of%20dark%20mysterious%20ninja%20figures%20in%20black%20robes%20under%20crimson%20moon%2C%20dramatic%20ink%20art%2C%20epic%20mood%2C%20no%20text&width=1200&height=600&seq=banner-yearly&orientation=landscape",
  },
];

export const testimonials = [
  { name: "忍忍不辍", role: "追更 3 年", avatar: "R", text: "「木叶的第七班日常」的每一话都像老朋友回家，画风和剧情都很用心，是我追得最久的同人。" },
  { name: "写轮眼的猫", role: "同人画手", avatar: "M", text: "题材分类整理得很清楚，找架空番外和恋爱番外特别方便，而且更新真的很及时。" },
  { name: "黄昏下的桥", role: "二次元老粉", avatar: "H", text: "从晓组织的视角重新读火影，很多情节有了全新理解，站内推荐质量很高，几乎没有踩雷。" },
  { name: "木叶在逃学员", role: "新读者", avatar: "Y", text: "第一次看同人漫画，界面清爽阅读很舒服，热门榜单帮我把该补的都补完了。" },
];

export const faqs = [
  {
    q: "火影同人漫画可以在线免费阅读吗？",
    a: "可以。本站收录的火影同人漫画均提供在线阅读入口，热门榜单、题材分类和最新更新板块中的作品都可以直接免费阅读，无需额外付费。",
  },
  {
    q: "这里的火影同人漫画是否无删减同步更新？",
    a: "是的。本站以「无删减同步追更」为原则，连载中的作品会按更新节奏整理章节，方便读者第一时间看到最新话。",
  },
  {
    q: "如何快速找到想看的火影同人漫画？",
    a: "你可以通过顶部的题材分类筛选，或直接在搜索框输入作品名称，系统会实时为你过滤出匹配的同人漫画，结果按热度与更新时间排序。",
  },
  {
    q: "热门榜单的排名依据是什么？",
    a: "热门榜单综合了作品的人气、追更人数与读者评分，定期更新，帮助你快速发现当下最受火影粉丝欢迎的同人作品。",
  },
  {
    q: "是否支持在手机和平板上阅读？",
    a: "支持。本站采用响应式设计，电脑、平板和手机都能流畅阅读，移动端菜单也可以正常展开和收起。",
  },
];

export const footerLinks = [
  { label: "热门榜单", href: "#rank" },
  { label: "题材分类", href: "#category" },
  { label: "最新更新", href: "#update" },
  { label: "必读推荐", href: "#featured" },
  { label: "常见问题", href: "#faq" },
];